export const MESSAGE_KEY = 'ONBOARDING_TOURS';
export const MESSAGE_ACTIONS = {
  CLOSE: 'close',
  TOUR_COMPLETED: 'tourCompleted'
};